import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import colors from "../../../styles/colors";
import AppFrame from "../../AppFrame";
import Title from "../../../components/common/Title";
import * as actionCreators from "../../../actions/apps";
import PatientComplianceReport from "../../../components/report/PatientComplianceReport";
import ReportService from "../../../services/reporting";
import sort from "fast-sort";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";

import _ from "lodash";

const style = {};

class PatientComplianceView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportAppId: props.apps.providerAppId,
      startDate: null,
      endDate: null,
      msg: "Please select a start and end date to run this report.",
    };

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.reloadReport = this.reloadReport.bind(this);
  }

  handleStartDateChange(date) {
    this.setState({ startDate: date });
  }
  handleEndDateChange(date) {
    this.setState({ endDate: date });
  }

  reloadReport() {
    try {
      if (this.state.startDate && this.state.endDate) {
        this.setState({ msg: "Fetching Data... Please Wait" });
        ReportService()
          .getPatientActivityReport(
            this.state.reportAppId,
            this.state.startDate.getTime(),
            this.state.endDate.getTime()
          )
          .then((resp) => {
            if (!resp || !resp.reportData) {
              this.setState({
                reportData: [],
                msg: "Error retrieving report data. Please check your date selection and try again.",
              });
              return;
            }
            let rows = [];
            sort(resp.reportData)
              .asc([(r) => r.lastName])
              .map((r) => {
                rows.push({
                  lastName: r.lastName,
                  firstName: r.firstName,
                  email: r.email,
                  totalPoints: r.totalPoints,
                  date: r.activityList[0].activityDate,
                  instruction: r.activityList[0].instructions,
                });

                for (let i = 1; i < r.activityList.length; i++) {
                  rows.push({
                    lastName: "",
                    firstName: "",
                    email: "",
                    totalPoints: "",
                    date: r.activityList[i].activityDate,
                    instruction: r.activityList[i].instructions,
                  });
                }
                return null;
              });

            this.setState({
              reportData: rows,
              msg: "Your Patients/Clients have not submitted activity for the selected timeframe.",
            });
          })
          .catch((err) => {
            this.setState({
              reportData: [],
              msg:
                (err && err.message) ||
                "Error retrieving report data. Please check your date selection and try again.",
            });
          });
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  componentWillReceiveProps(nextProps) {}

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }
    return (
      <AppFrame auth={this.props.auth} targetDevice={targetDevice}>
        <Title
          text1="Patient/Client Activity"
          text2="By Date Range"
          goBack={() => this.props.history.goBack()}
        />
        <Paper elevation={5} style={{ padding: 1, margin: 30 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              alignContent: "space-evenly",
              flex: 1,
            }}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                id="startDate-picker-inline"
                label="Start Date"
                value={this.state.startDate}
                onChange={this.handleStartDateChange}
                KeyboardButtonProps={{
                  "aria-label": "Change Start Date",
                }}
              />
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                id="endDate-picker-inline"
                label="End Date"
                value={this.state.endDate}
                onChange={this.handleEndDateChange}
                KeyboardButtonProps={{
                  "aria-label": "Change End Date",
                }}
              />
            </MuiPickersUtilsProvider>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={this.reloadReport}
              disabled={!this.state.startDate || !this.state.endDate}
              style={{ padding: 5, margin: 5 }}
            >
              {this.state.reportData ? "Refresh Report" : "Load Report"}
            </Button>
          </div>
        </Paper>
        <div style={{ width: "75%", marginLeft: "auto", marginRight: "auto" }}>
          <PatientComplianceReport
            appId={this.state.reportAppId}
            reportData={this.state.reportData}
            msg={this.state.msg}
          />
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps }) {
  return {
    user,
    apps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientComplianceView);



// WEBPACK FOOTER //
// ./src/layout/reporting/ChannelLevel/PatientComplianceReportView.js